<template lang="pug">
  .dropdown(
    @click.stop
  )
    .dropdown__item
      .dropdown__link(
        v-html="calcReason(order.current_status)"
      )
</template>
<script>
export default {
  name: "rejected-reason",
  props: ["order"],
  methods: {
    calcReason(status) {
      if (Number(status.reject_reason) === 1) {
        return "Недействительные документы:<br>" + status.documents_comment;
      }
      if (Number(status.reject_reason) === 2) {
        return "Не прошла по рейтингу";
      }
      if (Number(status.reject_reason) === 3) {
        return status.comment;
      }
    },
    onBodyClick() {
      this.$emit("close");
    },
  },
  created() {
    document.body.addEventListener("click", this.onBodyClick);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  },
};
</script>
